module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'has-navbar-fixed-top': _vm.UserId > 0
    }
  }, [_c('nprogress-container'), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loader",
    staticStyle: {
      "z-index": "1000"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Config != null && _vm.UserId > 0) ? _c('div', [_c('navbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }]
  }), _vm._v(" "), _c('sidebar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sidebar.opened && !_vm.sidebar.hidden),
      expression: "sidebar.opened && !sidebar.hidden"
    }]
  }), _vm._v(" "), _c('app-main')], 1) : _vm._e(), _vm._v(" "), (_vm.Config != null && _vm.UserId == 0) ? _c('section', {
    staticClass: "hero is-primary is-fullheight"
  }, [_c('div', {
    staticClass: "hero-body",
    staticStyle: {
      "padding-top": "1rem"
    }
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    ref: "username",
    staticClass: "input is-large",
    attrs: {
      "placeholder": "Username",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input is-large",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.Message) ? _c('div', {
    staticClass: "field"
  }, [_c('span', {
    staticClass: "has-text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.Message) + "\n                ")]), _vm._v(" "), _c('span', [_vm._v("\n                   \n                ")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-block is-info is-large is-fullwidth",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.DoLogin(true)
      }
    }
  }, [_vm._v("Login\n              ")]), _vm._v(" "), _c('br'), _vm._v(" "), (this.browsertype !== 'Google Chrome or Chromium' && this.browsertype !== 'Microsoft Edge') ? _c('span', {
    staticClass: "has-text-warning"
  }, [_vm._v("\n                You are using " + _vm._s(this.browsertype) + " as your browser. Please note that this browser is not supported by the VolleyAdmin3 web application.\n              ")]) : _vm._e()])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "avatar",
    staticStyle: {
      "margin-bottom": "2rem"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "4rem"
    },
    attrs: {
      "src": require("./assets/volleyball.svg")
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "titlefirst"
  }, [_vm._v("Volley")]), _c('span', {
    staticClass: "titlesecond"
  }, [_vm._v("Admin3")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8399f25c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 289
// module chunks = 11